import { render, staticRenderFns } from "./how-it-works.vue?vue&type=template&id=50abb13e&scoped=true"
import script from "./how-it-works.vue?vue&type=script&lang=js"
export * from "./how-it-works.vue?vue&type=script&lang=js"
import style0 from "./how-it-works.vue?vue&type=style&index=0&id=50abb13e&prod&scoped=true&lang=css"
import style1 from "./how-it-works.vue?vue&type=style&index=1&id=50abb13e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50abb13e",
  null
  
)

export default component.exports